import { h, Fragment } from "preact";
import { useState, useContext } from "preact/hooks";
import {

	Button,
	Box,
	Divider,
	Grid,
	Stack,
	Typography,
	Tooltip,

} from "@mui/material";

import InfoIcon from '@mui/icons-material/Info';
import FormField from "../Common/FormField";
import FormDate from "../Common/FormDate";
import FormSelect from "../Common/FormSelect";
import FormToggle from "../Common/FormToggle";
import FormMultiToggle from "../Common/FormMultiToggle";
import FormNumericPlusMinus from "../Common/FormNumericPlusMinus";
import FormSimpleBtn from "../Common/FormSimpleBtn";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { AppContext } from "../../AppContext";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import Ges from "../GES/";
import Dpe from "../DPE/";

export default function Appartement({ upperState, upperHandleChange }) {
	const [state, setState] = useState({ changes: false });
	console.log("render appartement", upperState)
	const app = useContext(AppContext);

	const handleChange = (event) => {
		//console.log(event)
		upperHandleChange(event);
	};
	const [anchorEl, setAnchorEl] = useState(null);

	const handlePopoverOpen = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handlePopoverClose = () => {
		setAnchorEl(null);
	};
	const setLines = (upperState, name, descr, gndr) => {

		//let max = upperState[name + "_lots"];

		let nm = name + "_metadata";
		var us = [...upperState[nm]];
		let max = us.length;
		//nnexeconsole.log("max is ", max, upperState, us, us.length, nm);
		//console.log("setLines", name, nm, us)
		function updateRow(e, o, ans, ans1) {
			//console.log("updateRow", e, us, o, ans, ans1)
			var row = us[o];
			row[ans1] = ans;
			us = us.filter((a) => { return a.id !== (row.id) })
			//console.log("us filtered is ", us)
			us = us.concat(row).sort((a, b) => {

				return (a.id > b.id) ? 1 : -1;

			})
			//console.log("us filtered is ", us)
			handleChange({ target: { name: nm, value: us } });
		}

		function delRow(e, o) {

			var row = us[o];
			//	console.log("delRow", e, o, row)
			if (row.adr === "Y" && row.uid !== undefined) {
				fetch("/api/170863aa8b334a5d98ecbe3ba298425b/" + row.uid)
					.then((response) => {
						return response.json();
					})
					.then((res) => {
						switch (res.res) {
							case "ok":

								window.location.reload();
								break;

							case "err":
								break;
							default:
								break;
						}
					});

			} else {
				us = us.filter((a) => { return a.id !== (row.id) })
				//	console.log("us filtered is ", us)
				us = us.sort((a, b) => {

					return (a.id > b.id) ? 1 : -1;

				})

				handleChange({ target: { name: nm, value: us } });
			}


		}

		function handleUpdateRow(e, o) {
			//	console.log("handleUpdateRow", e, us, o)
			//var row = us[o];
			updateRow(e, o, e.target.value, "lot")
		}

		var rows = [];

		for (let o = 0; o < max; o++) {
			//console.log("line", o)
			var row;

			row = us[o];

			rows.push(
				<Stack spacing={1} style="margin-left: 47px;">
					<Box display="flex" justifyContent="flex-end" alignItems="center">
						<Box>
							<Tooltip title="Supprimer">
								<DeleteForeverIcon
									style="cursor: pointer"
									color="primary"
									onClick={
										() => {
											app.refPopUp.current.handleChangeState(
												{
													opened: true, type: "002", params: {
														title: "Supprimer un bien", body: "...",
														yes_action: (e) => {
															delRow(e, o);
															app.refPopUp.current.handleChangeState(
																{
																	opened: false
																}
															);

														}
													}
												}
											)

										}}
								/>
							</Tooltip>
						</Box>
						{/* <Button variant="contained" onClick={(e) => { console.log(e, o, row, row.id) }}>III {o} {row.id}</Button> */}
						{!row.adr && <Box display="flex" justifyContent="space-between" alignItems="center" >
							<Box display="flex" justifyContent="flex-start" alignItems="center">

								<Box p={1}>
									<Typography variant="h5">{descr}</Typography>
								</Box>
								<Box p={1}>
									<ReportProblemIcon color="primary" />
								</Box>
								<Box p={1}>
									<Typography variant="h5">{gndr === "F" ? "La" : "Le"} {descr} est-{gndr === "F" ? "elle" : "il"} situé{gndr === "F" ? "e" : ""} dans la même copropriété à la même adresse ?</Typography>
								</Box>
							</Box>

							<Box>
								<Box display={"flex"} justifyContent="flex-end" alignItems={"center"} >
									<Box p={1}><Button variant="contained" onClick={(e) => { console.log("?", e, o, row); updateRow(e, o, "N", "adr") }}>Oui</Button></Box>
									<Box ><Button style="background-color: rgba(255, 52, 38, 0.08); color: rgba(255, 52, 38);" variant="contained" onClick={(e) => { console.log("?", e, o, row); updateRow(e, o, "Y", "adr") }}>Non</Button></Box>
								</Box>
							</Box>
						</Box >
						}
						{row.adr === "N" && <FormField upperState={{ ...row, lot_lbl: <Typography variant="h5">{descr}</Typography> }} key={row.id}
							id="lot"
							label={<Typography variant="h5">{descr} {row.id}</Typography>}
							//id={`row-${row.id}`} 
							placeholder="Lot"
							handleChange={(e) => handleUpdateRow(e, o)}
							helper={<Stack><Typography>Indiquer le numéro de lot de copropriété de la {descr}.</Typography></Stack>} />}
						{row.adr === "Y" && <Box display="flex" justifyContent="space-between" alignItems="center" >
							<Box display="flex" justifyContent="flex-start" alignItems="center">
								<Box p={1}>
									<InfoIcon aria-haspopup="true"
										aria-owns={open ? 'mouse-over-popover' : undefined}
										onMouseEnter={handlePopoverOpen}
										onMouseLeave={handlePopoverClose}
										style="margin-top: 6px;"

									/>
								</Box>
								<Box p={1}>
									<Typography variant="h5">{descr}</Typography>
								</Box>
							</Box>
							<Box>
								{!row.uid && <Typography>Vous serez invité à compléter les informations de ce bien ultérieurement.</Typography>}
								{row.uid && <Button onClick={() => {
									if (upperState.tunnel) {
										window.location.href = "/newdeala/" + row.uid + "/1";
									} else {
										window.location.href = "/dre0/" + row.uid + "/1";
									}

								}}>Voir</Button>}
							</Box>
						</Box >}
					</Box>
				</Stack >
				//{/* <FormField key={o} label={`Surface du lot ${o + 1}`} id="XXX" placeholder="Surf" handleChange={handleChange} value={upperState.floors} helper={<Stack><Typography>Indique la surface lot c...</Typography></Stack>} /> */}

			)
		}

		return rows
	}

	function addRow(name) {

		//let max = upperState[name + "_lots"];
		let nm = name + "_metadata";
		var us = [...upperState[nm]];
		//console.log("addRow", name, us)
		us = us.concat({ id: us.length, adr: null, lot: "" });
		//	console.log("us", us)
		handleChange({ target: { name: nm, value: us } });
		return;

	}

	//console.log("render Appartement", state, upperState);
	return (
		<Stack spacing={1}>


			<div style="max-width: 600px">
				<Grid container spacing={1}>
					<Grid item xs={12} >
						<Stack spacing={1}>

							<FormField upperState={upperState} id="surface" placeholder="Surface habitable en m2" handleChange={handleChange} num={true} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer la surface habitable du logement</Typography><Typography>dite "surface loi Carrez".</Typography></Stack>} />
							<FormNumericPlusMinus upperState={upperState} id="rooms" handleChange={handleChange} helper={<Stack><Typography>Il faut prendre en compte les pièces de moins de 30 m² et de plus de 9 m².</Typography><Typography>Les pièces telles que la cuisine, les toilettes,</Typography><Typography>la salle de bains ne doivent pas être prises en compte.</Typography><Typography>En revanche, une pièce d'une surface supérieure à 30 m² compte pour 2 pièces.</Typography></Stack>} />

							<Divider />
							<FormNumericPlusMinus upperState={upperState} id="bedrooms" placeholder="Nb" handleChange={handleChange} helper={<Stack><Typography variant="body1">Pour être considérée comme une chambre, une pièce doit :</Typography><Typography>- avoir une surface supérieure à 9m²,</Typography><Typography>- ne pas être aveugle.</Typography></Stack>} />
							<Divider />
							<FormNumericPlusMinus upperState={upperState} id="bathrooms" placeholder="Nb" handleChange={handleChange} helper={<Stack><Typography variant="body1">Indiquer le nombre de:</Typography><Typography>- salle de bains,</Typography><Typography>- salle de douches,</Typography><Typography>- salle d'eau.</Typography></Stack>} />
							<Divider />
							<FormNumericPlusMinus upperState={upperState} id="wc" placeholder="Nb" handleChange={handleChange} helper={<Stack><Typography variant="body1">Indiquer le nombre de</Typography><Typography>WC, indépendants ou non.</Typography></Stack>} />
							<Divider />
							<FormField upperState={upperState} id="floors" placeholder="Etage" handleChange={handleChange} num={true} max={60} helper={<Stack><Typography>Indiquer le nombre d'étages de l'immeuble.</Typography></Stack>} />
							{upperState.floors !== "" && <FormSelect upperState={upperState} id="floor" handleChange={handleChange} max={upperState.floors} helper={<Stack><Typography>Indiquer l'étage de l'appartement.</Typography></Stack>} />}

							<FormToggle upperState={upperState} id="has_elevator" handleChange={handleChange} />
							<Divider />
							{/* <FormToggle upperState={upperState} id="is_elec_15y" handleChange={handleChange} helper={<Stack><Typography>Installation électrique de plus de 15 ans</Typography></Stack>} />
							<FormToggle upperState={upperState} id="is_gaz_15y" handleChange={handleChange} helper={<Stack><Typography>Installation gaz de plus de 15 ans</Typography></Stack>} /> */}
							<FormMultiToggle upperState={upperState} options={[{ o: "49", l: "Avant 1949" }, { o: "97", l: "Entre les deux" }, , { o: "00", l: "Après 1996" }, { o: "?", l: "Ne sais pas" }]} id="construction_year" handleChange={handleChange} exclusive={true} helper={<Stack><Typography>Indiquer la période de construction de l'immeuble.</Typography></Stack>} />
							<Divider />
						</Stack>
					</Grid>
					<Grid item xs={12} >
						<Stack spacing={1}>
							<FormMultiToggle upperState={upperState} options={[{ o: "S", l: "SUD" }, { o: "N", l: "NORD" }, { o: "E", l: "EST" }, { o: "O", l: "OUEST" }]} label="Exposition" id="is_faced" handleChange={handleChange} helper={<Stack><Typography>Indiquer l'exposition du séjour.</Typography></Stack>} />
							<Divider />
							<FormToggle upperState={upperState} id="dpe_and_ges_available" handleChange={handleChange} helper={<Stack><Typography>Diagnostic de Performance Energétique.</Typography></Stack>} />

							{upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="dpe" placeholder="DPE" handleChange={handleChange} num={true} helper={<Stack spacing={1}><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette énergie</Typography><Dpe nb={upperState.dpe} /></Stack>} />)}
							{upperState.dpe_and_ges_available == "O" && (<FormField upperState={upperState} id="ges" placeholder="GES" handleChange={handleChange} num={true} helper={<Stack spacing={1}><Typography variant="body1">Reportez la valeur numérique indiquée dans le</Typography><Typography>Diagnostic de Performance Energétique.</Typography><Typography variant="h5">Etiquette climat</Typography><Ges nb={upperState.ges} /></Stack>} />)}
							<Divider />
							<FormField upperState={upperState} id="co_property_lots" placeholder="No" handleChange={handleChange} num={true} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer le numéro de lot de copropriété de l'appartement.</Typography></Stack>} />
							<FormField upperState={upperState} id="co_property_costs" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer les charges annuelles courantes.</Typography></Stack>} />
							<Divider />
							<FormField upperState={upperState} id="property_tax" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack><Typography>Indiquer la taxe foncière.</Typography></Stack>} />
							<Divider />
							<FormToggle upperState={upperState} id="is_not_free" handleChange={handleChange} helper={<Stack><Typography>Indiquez si le bien fait l'objet d'un contrat de location.</Typography></Stack>} />
							{upperState.is_not_free == "O" && (<FormField upperState={upperState} id="rent" placeholder="€/an" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer le montant du loyer annuel hors charges.</Stack>} />)}
							{upperState.is_not_free == "O" && (<FormDate upperState={upperState} id="rent_term" handleChange={handleChange} num={true} helper={<Stack spacing={1}>Indiquer la date de fin du contrat de location (bail).</Stack>} />)}
							<Divider />
						</Stack>
					</Grid>
					<Grid item xs={12} >
						<FormSimpleBtn upperState={upperState} label={`Cave${upperState.cellar_metadata.length > 1 ? "s" : ""}`} id="cellar_lots" handleChange={() => addRow("cellar")} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer s'il y a une ou pusieurs caves.</Typography></Stack>} />

						{upperState.cellar_metadata.length > 0 && setLines(upperState, "cellar", "Cave", "F")}
						<Divider />
						<FormSimpleBtn upperState={upperState} label={`Parking${upperState.parking_metadata.length > 1 ? "s" : ""}`} id="parking_lots" handleChange={() => addRow("parking")} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer s'il y a un ou pusieurs parkings.</Typography></Stack>} />
						{upperState.parking_metadata.length > 0 && setLines(upperState, "parking", "Parking", "M")}
						<Divider />
						<FormSimpleBtn upperState={upperState} label={`Chambre${upperState.attic_metadata.length > 1 ? "s" : ""} de service`} id="attic_lots" handleChange={() => addRow("attic")} disabled={upperState.mandate_signed} helper={<Stack><Typography>Indiquer s'il y une ou plusieurs chambres de service.</Typography></Stack>} />
						{upperState.attic_metadata.length > 0 && setLines(upperState, "attic", "Chambre de service", "F")}
					</Grid>

				</Grid >
			</div>


		</Stack >
	);
}


